module.exports = __webpack_public_path__ + "static/rnimu-452117714743bd7e4bd0693fb04ce7a5.png";